import type { CSSProperties } from "react";

export interface ImgPlaceholderProps {
  label: string;
  h?: number;
  style?: CSSProperties;
}

export function ImgPlaceholder({ label, h = 120, style }: ImgPlaceholderProps) {
  return (
    <div className="img-ph" style={{ height: h, ...style }}>
      <span>{label}</span>
    </div>
  );
}
